exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-tabs{border-bottom:1px solid #ddd;margin-bottom:5px}.nav-tabs a{color:#b2b2b2}.nav-tabs>li>a{border-color:transparent;border-bottom:3px solid transparent;transition:.3s all;font-size:16px}.nav-tabs>li>a:hover,.nav-tabs>li>a:focus{border-color:transparent;background:transparent;color:#265390}.nav-tabs>li.active>a{color:#265390;border-color:transparent;border-bottom:3px solid #265390}.nav-tabs>li.active>a:hover,.nav-tabs>li.active>a:focus{border-color:transparent;border-bottom:3px solid #265390;background:transparent}@media (max-width: 1366px){.nav-tabs>li>a{font-size:14px}}.tab:hover{cursor:pointer}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/tab/tab.scss
// module id = 1106
// module chunks = 0 1 2 3 4 5 6 7